import React, { useMemo } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { longDateString } from "../../utils";

function ZoneListingView({
    items,
    filterText,
    selectedRows,
    toggleCleared,
    onSelectedRowsChange,
    UI_STRINGS,
}) {
    const parentById = useMemo(() => {
        const m = new Map();
        items.forEach((z) => m.set(z.id, z));
        return m;
    }, [items]);

    const filteredItems = useMemo(() => {
        const q = filterText.trim().toLowerCase();
        if (!q) return items;
        return items.filter(
            (z) =>
                (z.name || "").toLowerCase().includes(q) ||
                (z.description || "").toLowerCase().includes(q)
        );
    }, [items, filterText]);

    const isSingle = selectedRows.length === 1;
    const isAnySelected = selectedRows.length > 0;

    const columns = [
        {
            name: "Parent",
            selector: (r) =>
                r.parent_id ? parentById.get(r.parent_id)?.name || "-" : "-",
            width: "220px",
            height: "50px",
            sortable: true,
        },
        {
            name: "Name",
            height: "50px",
            selector: (r) => r.name || "-",
            sortable: true,
            grow: 1.2,
        },
        {
            name: "Description",
            selector: (r) => r.description || "-",
            grow: 3,
            height: "50px",
            cell: (r) => (
                <div className="text-truncate h-50px" style={{ maxWidth: 250 }}>
                    {r.description || "-"}
                </div>
            ),
        },
        {
            name: "Activity",
            height: "50px",
            selector: (r) => r.updated_at,
            width: "250px",
            sortable: true,
            cell: (r) => {
                const tooltipText = `Created by ${
                    r.created_by?.name || "Unknown"
                } at ${
                    r.created_at ? longDateString(r.created_at) : "-"
                }\nModified by ${r.updated_by?.name || "Unknown"} at ${
                    r.updated_at ? longDateString(r.updated_at) : "-"
                }`;
                return (
                    <div style={{ fontSize: "0.85rem" }} title={tooltipText}>
                        {r.updated_by?.name || "Unknown"} at{" "}
                        {r.updated_at ? longDateString(r.updated_at) : "-"}
                    </div>
                );
            },
        },
    ];

    return (
        <DataTable
            columns={columns}
            data={filteredItems}
            selectableRows
            onSelectedRowsChange={onSelectedRowsChange}
            clearSelectedRows={toggleCleared}
            highlightOnHover
            striped
            pointerOnHover
            responsive
            pagination
            dense
            selectableRowsHighlight
            selectableRowsNoSelectAll={false}
        />
    );
}

export default ZoneListingView;
